export enum Language {
  english = 'en_US',
  spanish = 'es_ES',
  japanese = 'ja_JP',
  french = 'fr_FR',
  italian = 'it_IT',
  german = 'de_DE',
  dutch = 'nl_NL'
}
